<template>
  <div class="px-4 md:px-10 lg:px-20 pt-6 pb-3 space-y-4">
    <h1>
      {{ eventsListStore.pageInfo?.h1 }}
    </h1>
    <EventsFactLine />
  </div>
</template>

<script setup lang="ts">
const eventsListStore = useEventsListStore();
</script>
